import React from 'react';
import ReactDOM from 'react-dom';
import './theme/style.scss';
import App from './components/App/App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import { ApolloLink } from 'apollo-boost';
import { onError } from 'apollo-link-error';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';

const link = onError(({ graphQLErrors, networkError }) => {
	if (graphQLErrors) {
		graphQLErrors.map(({ message, locations, path }) =>
			console.error({ message, locations, path })
		);
	}
	if (networkError) console.log(`[Network error]: ${networkError}`);
});

const hostname = window.location.hostname;
let backendURI =
	{
		'admin.mcharraire.fr': 'https://server.admin.mcharraire.fr/graphql', // Prod

		'admin.mcharraire.web.adelios.fr':
			'http://backend.mcharraire.web.adelios.fr/graphql', // PreProd

		'admin.mcharraire.dev.adelios.fr':
			'http://backend.mcharraire.dev.adelios.fr/graphql', // Dev
	}[hostname] || 'http://localhost:4501/graphql'; // Local

const httpLink = createHttpLink({ uri: backendURI });

const authLink = new ApolloLink((operation, forward) => {
	const token = localStorage.getItem('token');
	if (token) {
		const authorizationHeader = `Bearer ${token}`;
		operation.setContext({
			headers: {
				authorization: authorizationHeader,
			},
		});
	}
	return forward(operation);
});

const client = new ApolloClient({
	link: link.concat(authLink.concat(httpLink)),
	cache: new InMemoryCache(),
});

ReactDOM.render(
	<BrowserRouter>
		<ApolloProvider client={client}>
			<App />
		</ApolloProvider>
	</BrowserRouter>,
	document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js